/* Etiquetas multiidoma en castellano. */
export default {
  "paymentView.paymentReference": "Referencia del pago",
  "paymentView.paymentType": "Tipo de pago",
  "paymentView.paymentType.CARD": "Tarjeta",
  "paymentView.paymentType.CASH": "Metálico",
};
